module.exports = __webpack_public_path__ + "img/call-topKV.a9340bd4.png";